import { memo } from 'react'
export default memo(({full=false}:{full?:boolean}):React.JSX.Element=><div className={`loader_wrapper ${full?'w-full':''}`}><div className='loader'></div></div>)